import { JitsiConference, JitsiConnection, JitsiLocalTrack, JitsiRemoteTrack } from 'lib-jitsi-meet'
import { EventChannel, eventChannel, SagaIterator } from 'redux-saga'
import { put, take, call } from 'redux-saga/effects'

function externalEventHandler(
  target: JitsiConference | JitsiConnection | JitsiLocalTrack | JitsiRemoteTrack,
  eventName: string
) {
  return eventChannel((emitter) => {
    function listener(...args: unknown[]) {
      emitter({ event: args })
    }

    target.addEventListener(eventName, listener, false)

    return () => {
      target.removeEventListener(eventName, listener, false)
    }
  })
}

function* bindEvent(
  target: JitsiConference | JitsiConnection | JitsiLocalTrack | JitsiRemoteTrack,
  eventName: string,
  callback: Function,
  externalEventChannels: EventChannel<unknown>[]
): SagaIterator {
  const channel = yield call(externalEventHandler, target, eventName)
  externalEventChannels.push(channel)
  try {
    while (true) {
      const { event }: { event: unknown[] } = yield take(channel)
      let payload: unknown = event

      switch (event.length) {
        case 0:
          payload = {}
          break
        case 1:
          payload = event.at(0)
          break
        default:
          payload = event
          break
      }
      yield put(callback(payload))
    }
  } finally {
    channel.close()
    externalEventChannels.splice(externalEventChannels.indexOf(channel), 1)
  }
}

export default bindEvent
